import { FunctionComponent } from "react";
import { data } from "../../data/offline-page-data.json";
import { Offline } from "../modules/offline/offline-page-component";

export const OfflinePageWrapper: FunctionComponent = () => {
  return <Offline data={data.offlinePage}></Offline>;
};

export default OfflinePageWrapper;
